<script>
  import Vue from 'vue'
  import { base64Decode } from 'vtils'
  import { dcb } from '@dcb/jssdk'
  import { router } from '@/router'

  export default Vue.extend({
    async created() {
      const { orderParams } = router.currentRoute.query
      if (orderParams) {
        const decodeParams = decodeURIComponent(orderParams)
        const paramsValue = base64Decode(decodeParams)
        const params = JSON.parse(paramsValue)

        await dcb.requestPayment({
          provider: 'native',
          showNativeResultPage: false,
          params: {
            ...params,
            unsupportedTips: undefined,
          },
        })
      }
    },
    render() {
      return null
    },
  })
</script>
